export default {
  dark: 'Tumma',
  light: 'Vaalea',
};
